export const isExternalLink = (url) =>
  !!['http', 'tel:', 'mailto:'].some((el) => url.includes(el))

export const prependSlashToInternalUrl = (url) =>
  (!isExternalLink(url) && url.substr(0, 1) !== '/' ? '/' : '') + url
